module.exports = __webpack_public_path__ + "blissweb-rg.7ee6f94918823c5426b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Rg/blissweb-rg.svg
// module id = 391
// module chunks = 5